import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import deviceController from '../../redux/api/tbDeviceController';
import telemetryController from '../../redux/api/tbTelemetryController';
import alarmController from '../../redux/api/tbAlarm';

const initialState = {
  tenantDevices: [],
  status: 'idle',
};

export const tenantDeviceInfos = createAsyncThunk(
  'tenantDeviceInfos',
  async (data) => {
    const { token } = data;
    const endTs = Date.now();
    const startTs = endTs - 86400000;
    let response = await deviceController.getTenantDeviceInfos(token, 'vts');
    const result = await Promise.all(
      response.data.map(async (item) => {
        let alarms = await alarmController.tb_getAlarms(
          token,
          item.id.entityType,
          item.id.id,
          0,
          5,
          startTs,
          endTs
        );

        let attributes = await telemetryController.getAttributesByScope(
          token,
          'DEVICE',
          item.id.id,
          'lastConnectTime,lastDisconnectTime,latitude,longitude,device_avatar,phoneList,lastActivityTime'
        );

        let avatar, lastActivityTime, lastConnectTime, lastDisconnectTime, latitude, longitude, phoneList;
        Object.values(attributes).map((item) => {
          if (item['key'] === 'phoneList') phoneList = item.value;
          if (item['key'] === 'device_avatar') avatar = item.value;
          if (item['key'] === 'lastActivityTime') lastActivityTime = item.value;
          if (item['key'] === 'lastConnectTime') lastConnectTime = item.value;
          if (item['key'] === 'lastDisconnectTime')
            lastDisconnectTime = item.value;
          if (item['key'] === 'latitude') latitude = item.value;
          if (item['key'] === 'longitude') longitude = item.value;
        });
        return {
          ...item,
          alarms: alarms.data,
          attributes: {
            lastActivityTime: lastActivityTime,
            lastConnectTime: lastConnectTime,
            lastDisconnectTime: lastDisconnectTime,
            avatar: avatar,
            longitude: longitude ? longitude : 0,
            latitude: latitude ? latitude : 0,
            phoneList: phoneList
          },
        };
      })
    );
    response.data = result;
    return response;
  }
);

export const changeAvatarDevice = createAsyncThunk(
  'changeAvatarDevice',
  async (data) => {
    const { token, deviceId, file } = data;
    const response = await telemetryController.saveEntityAttributesV1(
      token,
      'DEVICE',
      deviceId,
      {
        device_avatar: file,
      }
    );

    return response;
  }
);


export const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(tenantDeviceInfos.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(tenantDeviceInfos.fulfilled, (state, action) => {
      state.status = 'success';
      state.tenantDevices = action.payload;
    });
    builder.addCase(tenantDeviceInfos.rejected, (state) => {
      state.status = 'failed';
    });
    // change avatar
    builder.addCase(changeAvatarDevice.pending, (state) => {
      state.status = 'loading';
    });
    builder.addCase(changeAvatarDevice.fulfilled, (state, action) => {
      state.status = 'idle';
      toast.success('The avatar device has been changed successfully.');
    });
    builder.addCase(changeAvatarDevice.rejected, (state) => {
      state.status = 'failed';
      toast.error('Something went wrong!');
    });
  },
});

export default dashboardSlice.reducer;

export const allTenantDevices = (state) => state.dashboard.tenantDevices;
